// extracted by mini-css-extract-plugin
export default {"btnContainer":"style_btnContainer__O0Kuq","pizzaBtn":"style_pizzaBtn__BezUs","pastaBtn":"style_pastaBtn__l+oDf","dessertBtn":"style_dessertBtn__gP6fd"};